
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#3F3F3F","d":"M17.032 0h13.626v25H17.032z"}}),_c('path',{attrs:{"stroke":"#3F3F3F","d":"M.5.5h12.626v24H.5zm34.374 0H47.5v24H34.874z"}})])
          )
        }
      }
    